import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { onConflict, type ConflictDetail } from '../../lib/sync';
import { Button } from '../kit/Button';

export function ConflictModal() {
  const { t } = useTranslation('common');
  const nav = useNavigate();
  const [conflict, setConflict] = useState<ConflictDetail | null>(null);

  useEffect(() => {
    onConflict((c) => setConflict(c));
  }, []);

  if (!conflict) return null;

  return (
    <div
      className="fixed inset-0 bg-black/60 z-40 flex items-center justify-center p-6"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-[var(--color-surface,#fff)] rounded-[1.5rem] p-6 max-w-sm w-full shadow-xl">
        <h2 className="text-lg font-bold text-[var(--color-text)] mb-2">
          {t('conflict_title')}
        </h2>
        <p className="text-sm text-[var(--color-text-secondary)] mb-4">
          {conflict.response.message}
        </p>
        <Button onClick={() => { setConflict(null); nav(0); }}>
          {t('conflict_refresh')}
        </Button>
      </div>
    </div>
  );
}
